import _ from 'lodash'
import axios from 'axios'
import qs from 'qs'
import { validationMixin } from 'vuelidate'


var FormMessagesItem = {
  template: '<transition name="message"><div :class="classObject" v-if="show"><p v-html="message.text"></p></div></transition>',
  props: {
    // Message object: {type: '<error|info|warning|success>', text: '<text>', code: '<code>', duration: <duration>}
    message: Object
  },
  data: function () {
    return {
      show: true
    }
  },
  computed: {
    classObject: function () {
      var classes = {'message': true};
      classes['message--' + this.message.type] = true;
      classes['message--' + this.message.code] = true;
      return classes;
    }
  },
  mounted: function () {
    var vm = this;
    // Flash message for a period of time.
    if (vm.message.duration > 0) {
      setTimeout(function () { vm.show = false }, vm.message.duration);
    }
  }
};

var FormMessages = {
  components: {'form-messages-item': FormMessagesItem},
  template: '<div class="form-messages"><form-messages-item :message="message" v-for="message in messages" :key="message.code"></form-messages-item></div>',
  computed: {
    messages: function () { return this.$parent.formMessages; }
  }
};

var messagesMixin = {
  components: {'form-messages': FormMessages},
  props: {
    messageFlashDuration: {type: Number, default: 0}
  },
  data: function () {
    return {
      // A list of message objects.
      formMessages: [],
    }
  },
  methods: {
    addMessage: function (type, text, code, duration) {
      var message = {
        type: type,
        text: text,
        code: code || 'generic',
        duration: duration || this.messageFlashDuration
      };
      this.formMessages.push(message);
    },
    clearMessages: function () { this.formMessages = []; }
  }
};

var formMixin = {
  mixins: [validationMixin, messagesMixin],
  props: {
    url: {type: String, required: true},
    initial: Object,
    successMessage: String,
    successUrl: String,
    errorMessage: String
  },
  data: function () {
    return {
      formData: {},
      serverErrors: {},
      isDisabled: false,
      activeField: null,

      // Private. Accessible through the $data object.
      _state: 'input',
    }
  },
  computed: {
    // Computed state that procceses error state.
    // Can be set to a string 'input|send|error|failure|success'.
    state: {
      get: function () {
        if (this.$v.$error) this.$data._state = 'error';
        else if (this.$data._state === 'error') this.$data._state = 'input';
        return this.$data._state;
      },
      set: function (newValue) { this.$data._state = newValue; }
    },
    normalizedFormData: function () {
      // Normalizes form data into serializable values.
      var vm = this;
      var data = {};
      // Extract actual data from arrays and objects used in select fields.
      _.each(vm.formData, function (value, key) {
        if (_.isArray(value)) {
          var newValue = [];
          _.each(value, function (v, k) { newValue.push(v.value); });
          value = newValue;
        } else if (_.isObject(value)) value = value.value;
        data[key] = value;
      });
      return data;
    },
    serializedFormData: function () {
      // Returns data formated into 'application/x-www-form-urlencoded'.
      return qs.stringify(this.normalizedFormData, {indices: false});
    }
  },
  watch: {
    // Watch for initial change and update values.
    initial: function (newValue) { this.setFormData(newValue); }
  },
  validations: function () {
    var vm = this;
    var validations = vm.getValidations();
    // Add server (back-end) error validations.
    _.each(vm.serverErrors, function (errolist, name) {
      if (!validations[name]) validations[name] = {};
      validations[name].server = function () { return false };
    })
    return {formData: validations}
  },
  methods: {
    // Used to specify validation for fields.
    getValidations: function () { return {} },

    // Hook after success has beed reached. (note: passing in 'successUrl' as
    // a prop will redirect after success, hence this method will not be executed).
    afterSuccess: function (data) {},

    // Helpers.
    hasError: function (field) { return this.$v.formData[field] && this.$v.formData[field].$error },
    hasSuccess: function (field) { return !this.hasError(field) && this.$v.formData[field] && this.$v.formData[field].$dirty },

    // Event hooks that should be mapped on each field.
    onInput: function (field) {
      this.$delete(this.serverErrors, 'non_field_errors');
      this.$delete(this.serverErrors, field);
      if (this.$v.formData[field]) this.$v.formData[field].$touch();
    },
    onBlur: function (field) { if (this.$v.formData[field]) this.$v.formData[field].$touch(); },

    // Set form data values, accepts an object with key / value pairs.
    setFormData: function (data) {
      var vm = this;
      _.forOwn(data, function (value, key) {
        vm.$set(vm.formData, key, value);
        vm.$v.formData[key].$touch();
      });
    },

    // Handle form submit action.
    submit: function () {
      var vm = this;
      if (vm.isDisabled) return;
      vm.clearMessages();
      // Check if errors still exist and display message to user.
      vm.$v.$touch();
      if (vm.$v.$error) {
        if (vm.errorMessage) vm.addMessage('error', vm.errorMessage);
        return;
      }
      // Disable the form and send a post request with `formData` passed.
      vm.isDisabled = true;
      vm.state = 'send';
      axios.post(vm.url, vm.serializedFormData).then(function (response) {
        var data = response.data;
        vm.state = 'success';
        vm.$emit('success', data);
        // Either redirect if `successUrl` exists or show success message and trigger `afterSuccess` hook.
        if (vm.successUrl) window.location.href = vm.successUrl;
        else {
          // Show messages from server or as specified in `successMessage`.
          if (vm.successMessage) vm.addMessage('success', vm.successMessage);
          else if (data.success) vm.addMessage('success', data.success);
          vm.afterSuccess(data);
        }
      }).catch(function (error) {
        var data = error.response.data;
        if (data.error) {
          // Display a failure message.
          vm.state = 'failure';
          vm.$emit('failure', data);
          vm.addMessage('error', data.error);
        }
        else {
          // Handle server validation errors.
          vm.state = 'error';
          vm.$emit('error', data);
          // Handle Django `non_field_errors` case.
          if (data.non_field_errors) vm.addMessage('error', _.first(data.non_field_errors));
          // Set server form errors, re-enable the form.
          vm.serverErrors = data;
          vm.$v.$touch();
          vm.isDisabled = false;
        }
      });
    },
  },
  mounted: function () {
    if (this.initial) this.setFormData(this.initial);
  }
};

export { formMixin as default }



// WEBPACK FOOTER //
// ./assets/js/library/form.js